import styled from 'styled-components';
import ds from 'designsystem';
import { media } from 'designsystem/index';

const Header2 = styled.h2`
    color: ${ds.brand('text')};
    font-family: ${ds.get('type.fontFamily.headline')};
    font-weight: ${ds.get('type.fontWeight.bold')};
    line-height: ${ds.get('type.lineHeight.l')};
    font-size: ${ds.fs('l')};
    
    ${media.tablet`
      font-size: ${ds.fs('xl')};
      line-height: ${ds.get('type.lineHeight.xl')};
    `}
`;

export default Header2;



// WEBPACK FOOTER //
// ./src/elements/Header2.js